var PagePhotogalleryV2 = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_photogalleryv2',
		thumbs_amount: 7,
		data: null,
		in_popup: false,
		add_change_mode_options: false,
		missing_img : null,
		show_floorplan: null,
		width_image: 430,
		height_image: 0,
		width_thumb: 100,
		height_thumb: 70,
		videosOnly: false,
	},

	initialize: function(_element, options) {
		this.setOptions(options);
		this._element = _element;

		if (this._element) {
			this.build();
		}
	},

	build: function() {
		var self = this;
		if (this.options.data) {
			this.post_process_build(this.options.data);
		} else {
			var rpc = this._element.getProperty('data-rpc');
			if (rpc) {
				this._element.addClass('_loading');
				this.remote = new Remote({
					rpc: rpc,
					method: 'get',
					onSuccess: function() {
						self.post_process_build(this.get_data());
					}
				});
			} else {
				var _data_element = this._element.getElement('.pg_data');

				if (_data_element) {
					var data = JSONMOO.decode(_data_element.get('html'), false);
					this.post_process_build(data);
				} else {
					this._element.set('html', '').setStyles({ 'height': 'auto', 'background-color': '#fff', 'opacity': '0' });//NCR-3193, it could break something else because this is common widget and wanted to hide missing images in closing history

					var img_src =  (this.options.missing_img) ? this.options.missing_img : Res_i + '/l/not-found-horisontal-1.png';

					new Element('img', {'src': img_src, 'style': 'margin: 20px auto' }).inject(this._element);
				}
			}
		}
	},

	post_process_build: function(data) {
		if (!data || !data.content) {
			this.hide_gallery();
			return;
		}

		var fcls = '.' + this.options.cls,
			content = data.content,
			error_img_url = (this.options.missing_img) ? this.options.missing_img : Res_i + '/l/not-found-horisontal-1.png';

		if (!content) {
			return;
		}

		this._element.setStyle('position', 'relative');
		this._hidden = new Element('div', {'html': content, 'style': 'position: absolute; left: 0; right: 0; opacity: 0;' });
		this._element.adopt(this._hidden);
		this.popupContent = this._element.getElement('.w_blimp_content');

		this._pg = this._hidden.getElement(fcls);
		var _strip = this._strip = this._pg.getElement(fcls + '_strip');

		// NCR-5145 - if there's no listing gallery images and there is a floorplan, display the floorplan images instead.
		if (!this.options.videosOnly && data.photos && (!data.photos.length || this.options.show_floorplan) && data.floorplan && data.floorplan.length && !this.options.in_popup) {
			data.photos =  data.floorplan;
			this.isFloorplan = true;
		}

		if (!this.options.videosOnly) {
			if (data.photos && data.photos.length > 0) {
				data.photos.each(function(el, i) {
					if (el.length == 0) {
						return;
					}

					let _img_thumb,
						_img,
						size,
						_data_type;

					// this._element is photogalleryv2_container
					size = this._element.getSize();
					let photoWidth = Math.round(size.x * 0.7);
					let photoHeight = Math.round(size.y * 0.92);
					// old format (for buildings)
					if (Array.isArray(el)) {
						_img_thumb = el[1];
						_img = el[0].replace('smart/0x', 'smart/' + 'x' + photoHeight);
						_data_type = 'building';
					// new format (for listings)
					} else {
						// listing (photo|floor) thumb
						if (this.options.thumbs_amount) {
							_img_thumb = Core.get_smart_image(this.options.width_thumb, this.options.height_thumb, el);
						} else {
							_img_thumb = null;
						}
						
						// listing photo by 80% of size of main container
						if (this.options.in_popup && size.x && size.y) {
							_img = this._img = Core.get_smart_image(0, photoHeight, el);
						// listing floor
						} else if (!!size.x) {
							_img = this._img = Core.get_smart_image(size.x - 600, 0, el);
						}
						
						_data_type = 'listing';
					}

					var _thumb = new Element('button', {
						'aria-label': `View slide ${i+1}`,
						'class': 'thumb button-reset',
						'data-full': _img,
						'data-error': error_img_url,
						'data-show-floorplan': this.options.show_floorplan,
						'data-type': _data_type,
						'html': '<div class="thumb_veil"><i class="fa fa-check"></i></div>'
					});

					_thumb.paths = _img;

					new Element('img', {
						'src': _img_thumb,
						'onerror':'this.src = \'' + error_img_url + '\''
					}).inject(_thumb);

					_thumb.inject(_strip);
				}.bind(this));
				this.create_gallery();
			} else {
				this.hide_gallery();
			}
		}

		if (this.options.videosOnly) {
			if (data.videos && data.videos.length > 0) {
				let videos = data.videos;
				videos.each(function(el, i) {
					if (el.length == 0) {
						return;
					}

					let _img;

					var _thumb = new Element('button', {
						'aria-label': `View slide ${i+1}`,
						'class': 'thumb button-reset',
						'data-full': el,
						'data-fullscreen': el,
						'data-error': error_img_url,
						'html': '<div class="thumb_veil"><i class="fa fa-check"></i></div>',
						'type': 'video'
					});

					_thumb.paths = _img;

					new Element('img', {
						'src': el,
						'onerror':'this.src = \'' + error_img_url + '\''
					}).inject(_thumb);

					_thumb.inject(_strip);
				}.bind(this));

				this.create_gallery();
			} else {
				this.hide_gallery();
			}
		}

		if (!this.options.videosOnly && data.floorplan && data.floorplan.length > 0 && !this.isFloorplan) {
			this.create_floorplan_gallery(data);
		} else {
			this.fireEvent('callback');
		}
	},

	create_floorplan_gallery: function(data) {
		var _container;

		if (this.options.in_popup) {
			_container = (this._replacer || this._element).getParent('.w_popup').getElement('.lst_links');
		} else {
			_container = (this._replacer || this._element).getNext('.lst_links');
		}

		var fp_data = {
			photos: data.floorplan,
			content: data.content
		};

		var _fp_link;

		if (this.options.in_popup) {
			_fp_link = _container.getElement('._transparent.floorplan') || new Element('a', {'class': 'floorplan', 'html': '<span class="link-label">Floor Plan</span>', 'href': '#'});
		} else if (this.popupContent) {

			if (this._element.getAttribute('data-inner-floorplan') && this._element.getAttribute('data-inner-floorplan') == 'true') {
				_container = new Element('div',{'class': 'floorplan_link_container'}).inject(this._pg.getElement('.w_photogallery_main'), 'top');
			}

			_fp_link = new Element('a', {'class': 'w_blimp floorplan', 'html': '<i class="icon-floorplan big" aria-hidden="true"></i><span class="link-label">View floor plan</span>', 'href': '#', 'data-class': 'w_blimp'});

			var _photogallery_container = this.popupContent.getElement('.photogalleryv2_container');

			_photogallery_container.set('html', data.content);

			var html = this.popupContent.get('html');

			new Element('.w_blimp_content', {'html': html}).inject(_container,'top');

			new BlimpExtPhotogalleryV2(_fp_link, {
				draggable: true,
				data: fp_data,
			});
		}

		if (!_fp_link || !_container) {
			this.fireEvent('callback');

			return;
		}

		_fp_link.data = fp_data;

		if (this.options.in_popup) {
			var _photogallery_link =_container.getElement('a.photogallery');
			if (_photogallery_link) {
				_fp_link.inject(_photogallery_link, 'after');
			} else {
				_fp_link.inject(_container);
			}
		} else if (this.popupContent) {
			_fp_link.inject(_container,'top');
		}
		this.fireEvent('callback');
	},

	create_gallery: function() {
		if (!this._strip.getElement('.thumb')) {
			this.hide_gallery();
			return;
		}

		var self = this;
		var cls = this.options.cls
		var _pg = (this._pg.hasClass(cls) ? this._pg : this._pg.getElement('.' + cls));

		if (!_pg) {
			return;
		}
			
		this.pg = new PhotogalleryV2(_pg, {
			cls: 'w_photogalleryv2',
			width_by_thumbs: this.options.thumbs_amount,
			first_image: this._img,
			in_popup: this.options.in_popup,
			videos: this.options.videosOnly,
			show_floorplan: this.options.show_floorplan,
			
			onShowImage: function() {
				if (!self._img_load) {
					var _container;

					if (self._element.hasClass(cls)) {
						_container = self._element.getParent();
					} else {
						_container = self._element;
					}

					_container.empty();
					_container.removeClass('_loading');
					_container.adopt(self._pg);
					self._hidden.dispose();

					if (self.options.add_change_mode_options) {
						self.fireEvent('addChangeModeOptions');
					}
				}

				self._img_load = true;
			},
			onFirstImageLoad: function(_img) {
			}
		});
	},

	hide_gallery: function(){ 
		this._replacer = new Element('div', {
			'class': 'frame' + (this._element.getAttribute('data-class-onerror')? ' ' + this._element.getAttribute('data-class-onerror') : ''),
			'style': 'background: url(' + this._element.getAttribute('data-onerror') + ') center center no-repeat'
		}).inject(this._element, 'before');

		this._element.dispose();
	}
});
